import React, { createContext, useContext, useState, useEffect } from "react"

import { useRootQuery } from "graphql/smart-queries/user"
import { useCartState } from "shared/cart/context"
import { maybeGetActiveJourney } from "shared/user/helpers"
import { getBannerText } from "layouts/navigation/banner-helper"

type PromobarContentType = Maybe<string>
type PromobarHrefType = string | undefined

type PromobarContextType = {
  promobarContent: PromobarContentType
  setPromobarContent: (value: PromobarContentType) => void
  promobarHref: PromobarHrefType
  setPromobarHref: (value: PromobarHrefType) => void
}

const defaultValue = {
  promobarContent: "",
  setPromobarContent: () => null,
  promobarHref: undefined,
  setPromobarHref: () => null
}

export const PromobarContext = createContext<PromobarContextType>(defaultValue)

export const PromobarProvider: React.FC = ({ children }) => {
  const [promobarContent, setPromobarContent] = useState<PromobarContentType>(defaultValue.promobarContent)
  const [promobarHref, setPromobarHref] = useState<PromobarHrefType>(defaultValue.promobarHref)

  return (
    <PromobarContext.Provider
      value={{
        promobarContent,
        setPromobarContent,
        promobarHref,
        setPromobarHref
      }}
    >
      {children}
    </PromobarContext.Provider>
  )
}

export const usePromobar = () => useContext(PromobarContext)

export const useEffectPromobarContent = () => {
  const { data, loading } = useRootQuery()
  const {
    state: { cartItems }
  } = useCartState()
  const { setPromobarContent } = usePromobar()

  useEffect(() => {
    if (!loading && data) {
      const user = data.user
      const journey = maybeGetActiveJourney(user)
      const currentVanityUrlBannerText = data.currentVanityUrl?.topBannerText || undefined
      const currentOfferBannerText = data.currentOffer?.topBannerText || undefined

      const topBannerText = getBannerText({ cartItems, journey, currentVanityUrlBannerText, currentOfferBannerText })
      setPromobarContent(topBannerText)
    }
  }, [data, loading, setPromobarContent])
}
